import React from 'react';
import styled from 'styled-components';
import FontStyles from 'constants/font-styles';
import Colors from 'constants/colors';
import { applyStyles } from 'util/helpers';
import CustomMedia from 'util/custom-media-query';

const ErrorMessage = applyStyles(styled.span`
  display: block;
  color: ${Colors.orange1};

  &:first-of-type {
    margin-top: 6px;
  }
`)(
  CustomMedia.greaterThan('umedium')`
    ${FontStyles.text11};
  `,
  CustomMedia.lessThan('medium')`
    ${FontStyles.text9};
  `
);

const FormError = ({ error, touched }) => (
  <React.Fragment>
    {error &&
      touched &&
      (Array.isArray(error) ? (
        error.map((e, index) => <ErrorMessage key={index}>{e}</ErrorMessage>)
      ) : (
        <ErrorMessage>{error}</ErrorMessage>
      ))}
  </React.Fragment>
);

export default FormError;



// WEBPACK FOOTER //
// ./src/components/common/FormError/index.js